class PikachuEasterEgg extends HTMLElement {
  constructor() {
    super();
    this.maxEyeShift = 4; // px — subtle, per spec (3-5px)
    this.bounceMs = 500; // spec: bounce, then navigate after ~400-600ms
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.onAnimationEnd = this.onAnimationEnd.bind(this);
  }

  connectedCallback() {
    this.eyes = this.querySelectorAll('.pikachu-fab__eye');
    this.sound = this.querySelector('.pikachu-fab__sound');
    this.href = this.dataset.href;

    if (window.matchMedia('(hover: hover)').matches) {
      window.addEventListener('mousemove', this.onMouseMove, { passive: true });
      this.addEventListener('mouseenter', this.onMouseEnter);
    }

    this.addEventListener('click', this.onClick);
    this.addEventListener('keydown', this.onKeydown);
    this.addEventListener('animationend', this.onAnimationEnd);
  }

  disconnectedCallback() {
    window.removeEventListener('mousemove', this.onMouseMove);
    this.removeEventListener('mouseenter', this.onMouseEnter);
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('keydown', this.onKeydown);
    this.removeEventListener('animationend', this.onAnimationEnd);
  }

  playSound() {
    if (!this.sound) return;
    this.sound.currentTime = 0;
    this.sound.play().catch(() => {});
  }

  onMouseEnter() {
    this.playSound();
  }

  onMouseMove(event) {
    const rect = this.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;
    const angle = Math.atan2(event.clientY - cy, event.clientX - cx);
    const shiftX = Math.cos(angle) * this.maxEyeShift;
    const shiftY = Math.sin(angle) * this.maxEyeShift;

    this.eyes.forEach((eye) => {
      eye.style.transform = `translate(calc(-50% + ${shiftX}px), calc(-50% + ${shiftY}px))`;
    });
  }

  onKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.onClick();
    }
  }

  onClick() {
    if (this.classList.contains('is-bouncing')) return;
    this.classList.add('is-bouncing');

    window.setTimeout(() => {
      if (this.href) window.location.href = this.href;
    }, this.bounceMs);
  }

  onAnimationEnd(event) {
    if (event.animationName === 'pikachu-bounce') {
      this.classList.remove('is-bouncing');
    }
  }
}

customElements.define('pikachu-easter-egg', PikachuEasterEgg);
